import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/")({
  beforeLoad: () => {
    // Authenticated super_admin users landing on "/" get redirected to dashboard
    throw redirect({ to: "/dashboard" });
  },
});
